import { render, staticRenderFns } from "./marquee-boxer-item.vue?vue&type=template&id=58778861&scoped=true&"
import script from "./marquee-boxer-item.vue?vue&type=script&lang=js&"
export * from "./marquee-boxer-item.vue?vue&type=script&lang=js&"
import style0 from "./marquee-boxer-item.vue?vue&type=style&index=0&id=58778861&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58778861",
  null
  
)

export default component.exports